<template>
  <div class="schedule-day-title">
    <input-edit-in-place
       class="ttl"
       placeholder="Click to add day title..."
       name="title"
      :value="dietDay.title"
      @edited="onEditEvent">
    </input-edit-in-place>
    <input-edit-in-place
       class="note"
       placeholder="Click to add day description..."
       name="note"
      :value="dietDay.note"
      @edited="onEditEvent">
    </input-edit-in-place>
  </div>
</template>

<script>
import Vue from 'vue';
import InputEditInPlace from 'components/ui/input/nuttrema-input-edit-in-place';

export default {
  name: 'cmpt-schedule-day-title',
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
    dayID: {
      required: true,
      default: null,
    },
    dietDay: {
      type: Object,
      required: true,
      default: null,
    },
  },
  components: {
    InputEditInPlace,
  },
  methods: {
    onEditEvent(params) {
      const data = {};
      Vue.set(data, params.name, params.value);
      this.$emit('edited', {
        id: this.id,
        type: this.type,
        dayID: this.dayID,
        data,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .schedule-day-title {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/list/cmpt-schedule-day-title.vue